import { useContext } from 'react';
import { CustomNotificationContext } from '../contexts/CustomNotificationContext';

/**
 * Custom hook to use the notification context
 * This allows components to display notifications that are properly aligned with the main content
 * 
 * @returns {Object} Notification context with showNotification and hideNotification functions
 */
const useCustomNotification = () => {
  const context = useContext(CustomNotificationContext);
  
  if (!context) {
    // If not found, provide a fallback that logs to console
    console.warn('useCustomNotification called outside CustomNotificationProvider - using fallback');
    return {
      showNotification: (notification) => {
        console.log('Notification (fallback):', notification);
      },
      hideNotification: () => {}
    };
  }
  
  return context;
};

export default useCustomNotification;